define([], function () {
	'use strict';

	/**
	 * Loader
	 * A plugin that displays a loader in a DOM node.
	 * @exports loader
	 */
	var loader = {

		/** String containing the html for the loader. */
		loaderStr: '<span class="loader"><span class="is-visuallyhidden">${screenreaderText}</span></span>',

		/** String containing the html for the large loader. */
		loaderLargeStr: '<span class="loader loader-large"><span class="is-visuallyhidden">${screenreaderText}</span></span>',


		/**
		 * Start loading.
		 * @param {Object} el - A DOM node.
		 * @param {String} screenreaderText - A string containing a text for screenreaders.
		 * @param {String} size - The size as a string ('large' for a large loader, anything else for a standard loader).
		 * @public
		 */
		loadingStart: function (el, screenreaderText, size, storeInnerHtml) {
			var loaderString = this.loaderStr;

			if (screenreaderText === undefined) {
				screenreaderText = '';
			}

			if (size !== undefined && size === 'large') {
				loaderString = this.loaderLargeStr;
			}

			loaderString = loaderString.replace('${screenreaderText}', screenreaderText);

			if (storeInnerHtml !== undefined) {
				el.setAttribute('data-innerhtml', el.innerHTML);
			}

			el.innerHTML = loaderString;
		},


		/**
		 * Stop loading.
		 * @param {Object} el - A DOM node.
		 * @public
		 */
		loadingEnd: function (el) {
			var oldHtml = el.getAttribute('data-innerhtml');

			if (oldHtml !== null) {
				el.innerHTML = el.getAttribute('data-innerhtml');
			}
		}
	};


	return loader;
});


//////////////////
// WEBPACK FOOTER
// ./components/loader/loader.js
// module id = 14
// module chunks = 0